import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { CreateParticipantBehaviourRecording } from '../mutations/createParticipantBehaviourRecording.mutation';
import type {
  CreateParticipantBehaviourRecordingMutation,
  CreateParticipantBehaviourRecordingMutationVariables,
} from '../types';

export const useCreateParticipantBehaviourRecordingMutation = (
  options?: MutationOptions<
    CreateParticipantBehaviourRecordingMutation,
    CreateParticipantBehaviourRecordingMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantBehaviourRecording), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
